<!-- <div class="search-global">
  <input
    class="valid"
    type="text"
    name="name"
    maxlength="250"
    placeholder="Global Search"
    [formControl]="control"
    (keyup)="filterResults($event)"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete #auto="matAutocomplete">
    <mat-optgroup *ngFor="let group of filteredResults$ | async">
      <mat-label *ngIf="group.results.length > 0">
        {{ group.category | titlecase }}</mat-label
      >
      <mat-option
        *ngFor="let item of group.results"
        class="search-global"
        (click)="selectResult(item, group.category)"
        (onSelectionChange)="selectResult(item, group.category)"
      >
        <div fxLayout="row" fxLayoutAlign="start center">

          <ng-container *ngIf="group.category != 'leads'; else leads">
            <div fxFlex fxLayoutAlign="start center">
              {{ item.company_name }}
              <mat-icon>keyboard_arrow_right</mat-icon>
              <strong>{{ item.fd_number }}</strong>
              <mat-icon>keyboard_arrow_right</mat-icon>
              {{ item.vehicles_count }}
              {{ item.vehicles_count > 1 ? 'Cars' : 'Car' }}
              <mat-icon>keyboard_arrow_right</mat-icon>
              <strong>{{
                group.category && group.category | titlecase
              }}</strong>
            </div>
          </ng-container>
      
          <ng-template #leads>
            <div fxFlex fxLayoutAlign="start center">
              {{ item.company && item.company | titlecase }}
              <mat-icon>keyboard_arrow_right</mat-icon>
              <strong>{{ item.code }}</strong>
              <mat-icon>keyboard_arrow_right</mat-icon>
              <strong>{{
                group.category && group.category | titlecase
              }}</strong>
            </div>
          </ng-template>
        </div>
      </mat-option>
    </mat-optgroup>
  </mat-autocomplete>
</div> -->

<div class="search-global">
  <input
    class="valid"
    type="text"
    name="name"
    maxlength="250"
    placeholder="Global Search"
    [formControl]="control"
    (keyup)="filterResults($event)"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    panelWidth="auto"
    class="global-search-panel"
  >
    <mat-option
      *ngIf="this.filterValue"
      (click)="searchValueInModule('orders')"
    >
      Search "<strong>{{ this.filterValue }}</strong
      >" in the orders module
    </mat-option>
    <mat-option
      *ngIf="this.filterValue"
      (click)="searchValueInModule('quotes')"
    >
      Search "<strong>{{ this.filterValue }}</strong
      >" in the quotes module
    </mat-option>
    <mat-optgroup *ngFor="let group of filteredResults | async">
      <mat-label class="category" *ngIf="group.results.length > 0">
        {{ group.category | titlecase }}</mat-label
      >
      <mat-option
        *ngFor="let name of group.results"
        class="search-global"
        [value]="name.fd_number"
        (click)="selectResult(name, group.category)"
      >
        <!-- ORDERS -->
        <ng-container *ngIf="group.category != 'leads'; else leads">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div class="ml-2 mr-3" fxLayoutAlign="center start">
              <div class="circular">
                <!-- <img
                src="{{ environmentUrl + name.Quote.Company.photo }}"
                alt=""
                onerror="this.src='assets/images/icons/artboard.jpg'"
              /> -->
                <img src="assets/images/icons/artboard.jpg" alt="" />
              </div>
            </div>
            <div fxFlex fxLayoutAlign="start center">
              {{ name.Company?.name | titlecase }}
              <mat-icon>keyboard_arrow_right</mat-icon>
              <strong *ngIf="name.fd_number; else emptyCode">{{
                name.fd_number
              }}</strong>
              <ng-template #emptyCode>&#8226;&#8226;</ng-template>
              <mat-icon>keyboard_arrow_right</mat-icon>
              {{ name.quantity }}
              {{ name.quantity > 1 ? 'Vehicles' : 'Vehicle' }}
              <mat-icon>keyboard_arrow_right</mat-icon>
              <strong>{{
                (name.Status ? name.Status.name : '..')
                  | statusTranslatorG: true
                  | titlecase
              }}</strong>
            </div>
          </div>
        </ng-container>
        <ng-template #leads>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div class="ml-2 mr-3" fxLayoutAlign="center start">
              <div class="circular">
                <img
                  src="{{ environmentUrl + name.Company.photo }}"
                  alt=""
                  onerror="this.src='assets/images/icons/artboard.jpg'"
                />
                <!-- <img src="assets/images/icons/artboard.jpg" alt="" /> -->
              </div>
            </div>
            <div fxFlex fxLayoutAlign="start center">
              {{ name.Company?.name | titlecase }}
              <mat-icon>keyboard_arrow_right</mat-icon>
              <strong *ngIf="name.fd_number; else emptyCode">{{
                name.fd_number
              }}</strong>
              <ng-template #emptyCode>&#8226;&#8226;</ng-template>
              <mat-icon>keyboard_arrow_right</mat-icon>
              {{ name.Company?.shipper | titlecase }}
              <mat-icon>keyboard_arrow_right</mat-icon>
              <strong>{{
                (name.Status ? name.Status.name : '..')
                  | statusTranslatorG
                  | titlecase
              }}</strong>
            </div>
          </div>
        </ng-template>
      </mat-option>
    </mat-optgroup>
    <mat-option *ngIf="requesting">
      Loading search results...
    </mat-option>
  </mat-autocomplete>
</div>
